import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';

const { TwoFactorAuthenticationStatus } = SettingsConstants;

const TwoFactorAuthenticationUtils = {
  /**
   * Returns whether Two-Factor Authentication is enabled for the given state
   *
   * @param {state} current Two-Factor Authentication state
   */
  isEnabled(state: $TSFixMe) {
    return (
      state === TwoFactorAuthenticationStatus.ENABLED ||
      state === TwoFactorAuthenticationStatus.DISABLING_CONFIRMING_PASSWORD
    );
  },

  /**
   * Returns whether Two-Factor Authentication is disabled for the given state
   *
   * @param {state} current Two-Factor Authentication state
   */
  isDisabled(state: $TSFixMe) {
    return (
      state === TwoFactorAuthenticationStatus.DISABLED ||
      state === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_PASSWORD ||
      state === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_CODE
    );
  },
};

export default TwoFactorAuthenticationUtils;

export const { isEnabled, isDisabled } = TwoFactorAuthenticationUtils;
